// extracted by mini-css-extract-plugin
export default {"cls1":"Reader-cls1___c7dbbefeb0eed7cf0e4","cls2":"Reader-cls2__bab134ff9b715a02738d Reader-cls1___c7dbbefeb0eed7cf0e4"};